import { FC } from "react"
import s from "@pages/fid_view/styles.module.css"
import { Box, Typography } from "@mui/material"
import {
  cardInfo,
  cardInfoIcon,
  cardTitle,
} from "@components/CardEvent/CardEvent/CardEventStyles"
import CardAvatarRow from "@components/CardEvent/CardAvatarRow"

import WalletIconCard from "/src/assets/svg/card-icons-pack/Wallet-icon.svg?react"
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi"
import ParticipantList from "@components/ParticipantList"

export interface CostContentProps {
  eventInfo?: DetailedEventInSearchDto
}

const CostContent: FC<CostContentProps> = ({ eventInfo }) => {
  if (!eventInfo) return null
  return (
    <div className={s.description_box}>
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Стоимость:
      </Typography>
      <Box sx={cardInfo}>
        <div style={cardInfoIcon}>
          <WalletIconCard stroke={"var(--secondary-text)"} />
          <Typography variant="body2" color={`var(--secondary-text)`}>
            {eventInfo.is_free
              ? "Бесплатно"
              : eventInfo.event_price === null
              ? "Требуется плата за вход"
              : `${eventInfo.event_price?.toLocaleString("ru-RU")} руб.`}
          </Typography>
        </div>
      </Box>
      <ParticipantList
        participants={eventInfo.users_who_participants_of_event}
      />
    </div>
  )
}
export default CostContent
